{
  "acrabats.rovo-dev-spotlight.explore-rovo-dev.description": [
    {
      "type": 0,
      "value": "Get started on this work item using Rovo Dev to generate code. It's work is only visible to you."
    }
  ],
  "acrabats.rovo-dev-spotlight.explore-rovo-dev.heading": [
    {
      "type": 0,
      "value": "Start coding with Rovo Dev in Jira"
    }
  ],
  "acrabats.rovo-dev-spotlight.navigation.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "acrabats.rovo-dev-spotlight.navigation.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "acrabats.rovo-dev-spotlight.navigation.progress": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "acrabats.rovo-dev-spotlight.navigation.read-more": [
    {
      "type": 0,
      "value": "Read more"
    }
  ],
  "acrabats.rovo-dev-spotlight.understand-rovo-dev.description": [
    {
      "type": 0,
      "value": "Once the agent has finished, you're in control of approving the work and sharing with your team."
    }
  ],
  "acrabats.rovo-dev-spotlight.understand-rovo-dev.heading": [
    {
      "type": 0,
      "value": "You review and approve"
    }
  ],
  "devai-acrabats.blocks.header.alt_text.atlassian": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "devai-acrabats.components.email..footer.img.alt": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "devai-acrabats.components.email..footer.text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "devai-acrabats.components.email.footer.note.no-org-name": [
    {
      "type": 0,
      "value": "You received this because you're an organization admin"
    }
  ],
  "devai-acrabats.components.email.footer.note.org-name": [
    {
      "type": 0,
      "value": "You received this because you're an organization admin for "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message-template.email.subject": [
    {
      "type": 0,
      "value": "Rovo Dev is coming to the terminal"
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph": [
    {
      "type": 0,
      "value": "Learn more about how RovoDev CLI capabilities and its data use and controls "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph.link": [
    {
      "type": 0,
      "value": "here"
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.first-paragraph": [
    {
      "type": 0,
      "value": "Rovo Dev CLI brings powerful Rovo Dev capabilities, along with your team's Jira and Confluence\n\t\t\t\t\tknowledge, to your terminal."
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fourth-paragraph": [
    {
      "type": 0,
      "value": "Rovo Dev users will receive instructions soon for how to install Rovo Dev CLI and use it in your team's workflow."
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.heading": [
    {
      "type": 0,
      "value": "Rovo Dev CLI has been enabled for your site"
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.second-paragraph": [
    {
      "type": 0,
      "value": "Developers can collaborate with AI to generate and ship code, turn work items into features,\n\t\t\t\t\task questions in natural language, and more. And all without switching contexts."
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph": [
    {
      "type": 0,
      "value": "Rovo Dev CLI enables users to connect to third-party data sources via "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph.link": [
    {
      "type": 0,
      "value": "Model Context Protocol"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Rovo Dev is now ready to use in your terminal"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-1": [
    {
      "type": 0,
      "value": "Natural language insights into repositories, files, and features."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-2": [
    {
      "type": 0,
      "value": "AI-powered code generation and shipping."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-3": [
    {
      "type": 0,
      "value": "Collaboration with AI to turn work items into features."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-4": [
    {
      "type": 0,
      "value": "Connecting to third-party data sources via Model Context Protocol."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph": [
    {
      "type": 0,
      "value": "We've enabled access to Rovo Dev CLI for your site ("
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": ") as part of the Rovo Dev Agents beta."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph.link": [
    {
      "type": 1,
      "value": "siteName"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.heading": [
    {
      "type": 0,
      "value": "Your team can now use Rovo Dev CLI"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph": [
    {
      "type": 0,
      "value": "Once your team "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": ", they can access Rovo Dev features like:"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph.link": [
    {
      "type": 0,
      "value": "installs the agent in their terminal"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.third-paragraph.link": [
    {
      "type": 0,
      "value": "manage access for your site"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.read-more-button": [
    {
      "type": 0,
      "value": "Read more about Rovo Dev CLI"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-admin-email.test-message.email.body.third-paragraph": [
    {
      "type": 0,
      "value": "If you don't want your team to be able to access Rovo Dev CLI, "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Rovo Dev is now ready to use in your terminal"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-1": [
    {
      "type": 0,
      "value": "Natural language insights into repositories, files, and features."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-2": [
    {
      "type": 0,
      "value": "AI-powered code generation and implementation."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-3": [
    {
      "type": 0,
      "value": "Automated test creation to improve coverage metrics."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-4": [
    {
      "type": 0,
      "value": "Dynamic documentation writing reflecting repository features and changes."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.first-paragraph": [
    {
      "type": 0,
      "value": "We've enabled access to Rovo Dev CLI as part of the Rovo Dev Agents beta."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.heading": [
    {
      "type": 0,
      "value": "You can now use Rovo Dev CLI"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.img.alt": [
    {
      "type": 0,
      "value": "Rovo Dev CLI Screenshot"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1": [
    {
      "type": 0,
      "value": "Install ACLI (or update to the latest version if you already have ACLI installed) using instructions for your OS:"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-1": [
    {
      "type": 0,
      "value": "macOS"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-2": [
    {
      "type": 0,
      "value": "Linux"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-3": [
    {
      "type": 0,
      "value": "Windows"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2": [
    {
      "type": 0,
      "value": "Generate an unscoped API token from your  "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2.link": [
    {
      "type": 0,
      "value": "Atlassian profile"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3": [
    {
      "type": 0,
      "value": "In your terminal, run:"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3.code": [
    {
      "type": 0,
      "value": "acli rovodev auth login"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4": [
    {
      "type": 0,
      "value": "Run this command to open Rovo Dev in interactive mode:"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4.code": [
    {
      "type": 0,
      "value": "acli rovodev run"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph": [
    {
      "type": 0,
      "value": "Once you "
    },
    {
      "type": 1,
      "value": "link"
    },
    {
      "type": 0,
      "value": ", you can access Rovo Dev features like:"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph.link": [
    {
      "type": 0,
      "value": "install the agent in your terminal"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.read-more-button": [
    {
      "type": 0,
      "value": "Read more about Rovo Dev CLI"
    }
  ],
  "devai-acrabats.rovo-dev-cli-rollout-user-email.test-message.email.body.sub-header": [
    {
      "type": 0,
      "value": "How do I get started?"
    }
  ],
  "jiraRovoDev.survey.question": [
    {
      "type": 0,
      "value": "Rovo Dev in Jira is valuable to my work."
    }
  ],
  "jiraRovoDev.survey.score.neutral": [
    {
      "type": 0,
      "value": "Neutral"
    }
  ],
  "jiraRovoDev.survey.score.stronglyAgree": [
    {
      "type": 0,
      "value": "Strongly agree"
    }
  ],
  "jiraRovoDev.survey.score.stronglyDisagree": [
    {
      "type": 0,
      "value": "Strongly disagree"
    }
  ],
  "jiraRovoDev.survey.statement": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the statement?"
    }
  ],
  "post-office.jira-rovo-dev-spotlight-walkthrough.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ]
}